import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    infoBoxContainer: {
        marginBottom: 40,
    },
}));
